export const DASHBOARDS_KEY = 'Dashboards';
export const DASHBOARDS_PATH = '/dashboards';
